import { isEmpty } from "lodash";

import { getFormattedAddress, isNil } from "../../utils";
import { ServiceProvider } from "../../models/ServiceProvider";

export const extractFields = (item: any, masterServiceProvider?: ServiceProvider[]) => {
  if (!isNil(item.mfaType)) {
    return {
      label: item.mfaType,
      value: item.mfaId,
    };
  }
  if (!isNil(item.roleType)) {
    return {
      label: item.roleType,
      value: item.roleId,
    };
  }
  if (!isNil(item.providerNpi)) {
    return {
      label:
        item.providerName +
        ", " +
        item.providerAddress +
        ", " +
        item.providerNpi,
      value: item.serviceProviderId,
      name: item.providerName,
      address: `NPI: ${item.providerNpi} , ${item.providerAddress}`,
    };
  }
  if (!isNil(item.serviceProviderId)) {
    return {
      label: item.name + ", " + getFormattedAddress(item, masterServiceProvider ?? []) + ", " + item.npiId,
      value: item.serviceProviderId,
      address: item.providerAddress,
    };
  }
  if (!isNil(item.payerName)) {
    return {
      label: item.payerName,
      value: btoa(`${item.payerId}|||${item.payerName}`),
    };
  }
  if (!isNil(item.ntuReasonId)) {
    return {
      label: item.ntuReason,
      value: item.ntuReasonId,
    };
  }
  if (!isNil(item.careTypeId)) {
    return {
      label: item.careTypeName,
      value: item.careTypeId,
    };
  }
  if (!isNil(item.communicationTypeId)) {
    return {
      label: item.communicationType,
      value: item.communicationTypeId,
    };
  }
  if (!isNil(item.referralSourceTypeId)) {
    return {
      label: item.referralSourceTypeName,
      value: item.referralSourceTypeId,
    };
  }
  if (!isNil(item.icdDiagnosisCodeId && !isEmpty(item.icdCode))) {
    if (item.icdDiagnosisCodeId > 0) {
      return {
        label: item.icdCode + "-" + item.icdDescription,
        value: item.icdDiagnosisCodeId,
      };
    }
    return {
      label: "No Records",
      value: null,
    };
  }
  if (!isNil(item.documentTypeId)) {
    return {
      label: item.documentName,
      value: item.documentTypeId,
    };
  }
  if (!isNil(item.documentNoteId)) {
    return {
      label: item.documentNote,
      value: item.documentNoteId,
    };
  }
  if(!isNil(item.dischargeReasonId)) {
    return {
      label: item.dischargeReason,
      value: item.dischargeReasonId,
    };
  }
  if(!isNil(item.notificationTypeId)) {
    return {
      label: item.notificationType,
      value: item.notificationTypeId,
    };
  }
  return item;
};
